import Vue from 'vue';

import { formatDate } from './formatDate';
import { formatPhone } from './formatPhone';
import { formatDateTime } from './formatDateTime';
import { pluralize } from './pluralize';
import { formatDatePeriod } from "./formatDatePeriod";
import { formatDatePeriodShort } from "./formatDatePeriodShort";
import { formatDuration } from "./formatDuration";
import { formatTime } from "./fromatTime";
import {formatDateShort} from "./formatDateShort";
import { formatDateWithShortYearAndMonth } from "./formatDateWithShortYearAndMonth";
import { formatDateTimeWithShortYearAndMonth } from "./formatDateTimeWithShortYearAndMonth";

Vue.filter('pluralize', pluralize);
Vue.filter('formatDate', formatDate);
Vue.filter('formatPhone', formatPhone);
Vue.filter('formatDateTime', formatDateTime);
Vue.filter('formatDatePeriod', formatDatePeriod);
Vue.filter('formatDatePeriodShort', formatDatePeriodShort);
Vue.filter('formatDuration', formatDuration);
Vue.filter('formatTime', formatTime);
Vue.filter('formatDateShort', formatDateShort);
Vue.filter('formatDateWithShortYearAndMonth', formatDateWithShortYearAndMonth);
Vue.filter('formatDateTimeWithShortYearAndMonth', formatDateTimeWithShortYearAndMonth);
